import { Mail, RotateCcw } from "lucide-react";
import { fullName } from "@/lib/format";
import { L } from "@/i18n";
import { StatusBadge } from "@/components/dashboard/StatusBadge";
import { PlanBadge } from "@/components/users/PlanBadge";
import { UserActions } from "@/components/users/UserActions";

export const ProfileHeader = ({ user, isSelf, onRequest, onReset }) => (
  <div className="rounded-lg bg-[#131f37] border border-[#1e293b] p-5 sm:p-6 mb-6 flex flex-col md:flex-row md:items-center gap-5" data-testid="student-header">
    <div className="h-14 w-14 shrink-0 rounded-full bg-amber-500/10 border border-amber-500/40 grid place-items-center font-heading text-xl font-bold text-amber-400">
      {(user.first_name || user.username)?.[0]?.toUpperCase()}
    </div>
    <div className="min-w-0 flex-1">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-50 truncate" data-testid="student-name">{fullName(user)}</h1>
      <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-slate-400">
        <span className="font-mono" data-testid="student-username">@{user.username}</span>
        <span className="flex items-center gap-1.5" data-testid="student-email"><Mail className="h-3.5 w-3.5" />{user.email}</span>
        <span data-testid="student-status"><StatusBadge status={user.status} /></span>
        <span data-testid="student-plan"><PlanBadge user={user} /></span>
        <span className="font-mono uppercase text-[11px]">{user.role}</span>
      </div>
    </div>
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onReset}
        disabled={isSelf}
        data-testid="student-reset-progress-button"
        className="flex items-center gap-2 rounded-md border border-rose-500/40 px-3 py-2 text-xs font-medium text-rose-300 hover:bg-rose-500/10 transition-colors disabled:opacity-40"
      >
        <RotateCcw className="h-3.5 w-3.5" /> {L("Reset progress", "Reset de progresso")}
      </button>
      <div className="rounded-md border border-slate-700">
        <UserActions user={user} isSelf={isSelf} onRequest={onRequest} />
      </div>
    </div>
  </div>
);
